import * as React from 'react';
import { SVGProps } from 'react';

const SvgCalendarOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 3a1 1 0 0 0-1 1v1H6a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V4a1 1 0 1 0-2 0v1H9V4a1 1 0 0 0-1-1ZM5 9h14v9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9Zm8 2h-2v2h2v-2Zm-4 0v2H7v-2h2Zm4 4h-2v2h2v-2Zm4 0v2h-2v-2h2Zm-8 0H7v2h2v-2Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgCalendarOutlined;
